import onboardingSlices from './slices';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const devtoolsInstance = devtools(onboardingSlices, {
  name: 'onboardingStore',
});

const useOnboardingStore = create(devtoolsInstance);

export default useOnboardingStore;
